import React, { useEffect } from "react";
import MiniDrawer from "../../Component/newNavBarCM/newNavBar";
import { Tabs, Tag } from "antd";
import { bindActionCreators } from "redux";
import ExpertRecordsTable from "../../Component/ExpertRecordsTable/ExpertRecordsTable";
import { useDispatch, useSelector } from "react-redux";
import {filterDomainsForComponent2} from "./../../utils"
import { Actions } from "../../Action";
import { useLocation, useNavigate } from "react-router-dom";
import Layout from '../../NewComponent/LayoutCM/Layout';
const containerStyle = {
  width: "95%",
  margin: "auto",
  marginTop: "1%",
  marginBottom: "7%",
  border: "1px solid #E0E2E6",
  background: "#FFFFFF",
  borderRadius: "12px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  padding: "28px",

};
const TabsForEC = () => {
  const expertRecordsState = useSelector(state=>state.expertRecord);
  const TabHeadings = (text) => {
    return <span style={{ fontSize: "20px", color: "black" }}>{text}{!expertRecordsState.isLoading && expertRecordsState.tabsearch ==="" && <Tag color='darkgrey' style={{marginLeft:'5px', fontSize:'18px', cursor:'default'}}>{expertRecordsState.totalCount==0?0:((expertRecordsState.pageNo-1)*20)+1} to {((expertRecordsState.pageNo-1)*20)+expertRecordsState.data.length} of {expertRecordsState.totalCount*2}</Tag>}</span>;
  };
  const TabHeadings2 = (text) => {
    return <span style={{ fontSize: "1rem", color: "black" }}>{text}</span>;
  };
  const items = [
    {
      key: "1",
      // label: TabHeadings("Expert Records"),
      label: TabHeadings("Expert Responses"),
      children: <ExpertRecordsTable />,
    },
    // {
    //   key: "2",
    //   label: TabHeadings2("Similarity Curation"),
    //   children: "Content of Tab Pane 2",
    //   disabled:true
    // },
  ];
  const onChange = (key) => {
    // console.log(key);
  };
  return <Tabs defaultActiveKey="1" items={items} onChange={onChange} />;
};


export default function MainPage() {
  const dispatch = useDispatch()
  const {cmRootUpdateDomainVal} = bindActionCreators(Actions,dispatch)
  const userState = useSelector(state=>state.user)
  const expertRecordsState = useSelector(state=>state.expertRecord);
  const currentPath = useLocation()

  useEffect(() => {
    return (() => {
      // if (expertRecordsState.selectedDomainName !== null && expertRecordsState.selectedDomainName.domainId !== null) {
      //   let newArray2 = expertRecordsState.selectedDomainName.domainId.split(',')
      //   let newArray3 = filterDomainsForComponent2(userState.cmTopics)
      //   let result = newArray3.filter(item => newArray2.includes(item.indexId))
      //   cmRootUpdateDomainVal(result)
      // }
    })
  }, [])

  return (
    <Layout>
      <div style={containerStyle}>
      <ExpertRecordsTable />
      </div>
    </Layout>
  );
}
